var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "twitter--path-1",
    points: "0 0 16 0 16 15.9998632 0 15.9998632"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.000000, -146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "twitter--mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#twitter--path-1"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M15.99968,8.09528 C15.94688,12.51288 12.32288,16.05208 7.90528,15.99928 C3.48688,15.94648 -0.05152,12.32248 0.00048,7.90488 C0.05248,3.48648 3.67728,-0.05192 8.09488,8e-05 C12.51328,0.05288 16.05168,3.67768 15.99968,8.09528",
    fill: "#2AA9E0",
    mask: "url(#twitter--mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.36536,5.36368 C12.04456,5.50128 11.70056,5.59328 11.34056,5.63168 C11.71016,5.41568 11.99656,5.07088 12.13416,4.65728 C11.78776,4.85728 11.40616,5.00048 10.99976,5.07568 C10.67976,4.72608 10.21976,4.50448 9.70936,4.49808 C8.72696,4.48688 7.92136,5.27328 7.91016,6.25488 C7.90856,6.39488 7.92216,6.53008 7.95016,6.66128 C6.47416,6.56928 5.17256,5.84608 4.30856,4.75968 C4.15176,5.02048 4.06056,5.32528 4.05656,5.65088 C4.04936,6.26768 4.35656,6.81488 4.83016,7.13968 C4.53896,7.12768 4.26616,7.04448 4.02776,6.90768 C4.02696,6.91488 4.02696,6.92288 4.02696,6.93008 C4.01656,7.79168 4.62136,8.51728 5.43256,8.69088 C5.28296,8.73008 5.12536,8.74928 4.96376,8.74768 C4.84856,8.74608 4.73816,8.73328 4.62936,8.71168 C4.84776,9.42048 5.49736,9.94288 6.27576,9.96608 C5.66136,10.43568 4.89096,10.71088 4.05816,10.70048 C3.91496,10.69888 3.77336,10.68928 3.63496,10.67088 C4.41496,11.18448 5.34696,11.49008 6.35016,11.50208 C9.62056,11.54128 11.44136,8.85328 11.46936,6.50368 C11.47016,6.42688 11.46936,6.35008 11.46696,6.27328 C11.81656,6.02688 12.12216,5.71728 12.36536,5.36368",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.468a19d1.svg";
export { ForwardRef as ReactComponent };